<template>
  <header class="quest-header">
    <div v-if="formattedDuration" class="quest-header__timer-controls">
      <div
        v-if="stopwatchVisible"
        class="quest-header__duration"
        @click="handleToggleStopwatch">
        {{ formattedDuration }}
      </div>
      <button
        v-else
        class="quest-header__show-stopwatch-btn"
        @click="handleToggleStopwatch">
        <HourglassIcon class="quest-header__stopwatch-icon" />
      </button>

      <button
        v-if="!questFinished"
        class="quest-header__pause-btn"
        :class="{ 'quest-header__pause-btn--active': pauseRequested }"
        @click="handlePauseClick"
        :title="pauseButtonTitle">
        <PauseIcon class="quest-header__pause-icon" />
      </button>
    </div>
  </header>
</template>

<script>
import HourglassIcon from "@images/font_awesome/hourglass-half-light.svg";
import PauseIcon from "@images/font_awesome/pause-circle-light.svg";

export default {
  name: "QuestHeader",
  components: {
    HourglassIcon,
    PauseIcon
  },
  data() {
    return {
      stopwatchVisible: true
    }
  },
  props: {
    formattedDuration: {
      type: String,
      default: ""
    },
    questFinished: {
      type: Boolean,
      default: false
    },
    pauseRequested: {
      type: Boolean,
      default: false
    },
    pauseButtonTitle: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleToggleStopwatch() {
      this.stopwatchVisible = !this.stopwatchVisible;
    },
    handlePauseClick() {
      this.$emit("pause-click");
    }
  }
}
</script>

<style lang="scss">
.quest-header {
  display: flex;
  justify-content: flex-end;

  &__timer-controls {
    display: flex;
    align-items: center;
    gap: $px12;

    flex-wrap: nowrap;
    white-space: nowrap;
  }

  &__duration {
    display: flex;
    align-items: center;
    height: $px24;

    color: $grey-7;
    @include font-small;

    cursor: pointer;
    user-select: none;
    transition: opacity .2s ease-in-out;

    &:hover {
      color: $grey-6;

      opacity: 0.7;
    }
  }

  &__show-stopwatch-btn {
    padding: 0;

    border: none;

    background: none;

    color: $grey-8;
    font-size: inherit;
    text-decoration: underline;

    cursor: pointer;
    transition: color .2s ease-in-out;

    &:hover {
      color: $grey-6;
    }
  }

  &__stopwatch-icon {
    height: 22px;
    max-width: 22px;
    max-height: 22px;
    padding: 0;
    margin: 0;

    color: $grey-7;

    line-height: 1;
    vertical-align: middle;

    cursor: pointer;
    transition: all .2s ease-in-out;
    appearance: none;

    &:hover {
      color: $grey-6;

      transform: scale(1.2);
    }
  }

  &__pause-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: $px24;
    height: $px24;
    padding: 0;
    margin: 0;

    border: 0;
    border-radius: 50%;

    background: none;

    color: $grey-7;
    line-height: 1;
    vertical-align: middle;

    cursor: pointer;
    transition: all .2s ease-in-out;
    appearance: none;

    &:hover {
      box-shadow: 0 0 $px4 $px2 rgba(#ffeb41, 0.9);

      background-color: #ffeb41;

      transform: scale(1.2);
    }

    &--active {
      box-shadow: 0 0 $px4 $px2 rgba(#ffeb41, 0.9);

      background-color: #ffeb41;

      color: $grey-6;

      &:hover {
        box-shadow: none;

        background-color: transparent;
      }
    }
  }

  &__pause-icon {
    width: $px24;
    height: $px24;

    color: $grey-7;

    transition: all .2s ease-in-out;

    &:hover {
      color: $grey-6;
    }
  }
}
</style>
